export enum TrackingEventsEnum {
  MAIN_BANNER_CLICK = "Main banner click",
  SECONDARY_BANNER_CLICK = "Secondary banner click",
  PARTNER_CLICK = "Partner click",
  PARTNER_AFFILIATE_LINK_CLICK = "Partner Affiliate link click"
}

export enum Role {
  SUPER_ADMIN = 0,
  TENANT_ADMIN = 1,
  ORG_ADMIN = 2,
  MANAGER = 3,
  COACH = 4,
  ASSOCIATES = 5,
  END_USER = 6,
}

export enum ClaimStatusEnum {
  OPEN = 1,
  CLOSED = 2,
  PENDING = 3,
  REJECTED = 4,
  WITHDRAWN = 5
}

export enum PlanForTrainingEnum {
  FULL = 1,
  PARTIAL = 2,
  NONE = 3,
}

export enum UserRoleEnum {
  SUPER_ADMIN = "SUPER_ADMIN",
  TENANT_ADMIN = "TENANT_ADMIN",
  CLAIM_MANAGER = "CLAIM_MANAGER",
  ORG_ADMIN = "ORG_ADMIN", // Coach
  REHAB_MANAGER = "REHAB_MANAGER",
  CLAIMANT = "CLAIMANT",
  EMPLOYER = "EMPLOYER"
}

export const PlanForTrainingDescription: { [key in PlanForTrainingEnum]: string } = {
  [PlanForTrainingEnum.FULL]: "Full training",
  [PlanForTrainingEnum.PARTIAL]: "Training with modification",
  [PlanForTrainingEnum.NONE]: "No training",
}

export enum CaseStatusEnum {
  OPEN = 1,
  CLOSED = 2,
}

export const CaseStatusDescription: { [key in CaseStatusEnum]: string } = {
  [CaseStatusEnum.OPEN]: "Open",
  [CaseStatusEnum.CLOSED]: "Closed",
};

export const ClaimStatusDescription: { [key in ClaimStatusEnum]: string } = {
  [ClaimStatusEnum.OPEN]: "Open",
  [ClaimStatusEnum.CLOSED]: "Closed",
  [ClaimStatusEnum.PENDING]: "Pending",
  [ClaimStatusEnum.REJECTED]: "Rejected",
  [ClaimStatusEnum.WITHDRAWN]: "Withdrawn",
};

export enum UseCaseTemplateTypeEnum {
  UNKNOWN = 0,
  CLAIM = 1,
  CASE = 2
}

export const UseCaseTemplateTypeDescriptions: { [key in UseCaseTemplateTypeEnum]: string } = {
  [UseCaseTemplateTypeEnum.UNKNOWN]: "UNKNOWN",
  [UseCaseTemplateTypeEnum.CLAIM]: "Claim",
  [UseCaseTemplateTypeEnum.CASE]: "Case"
}

export enum QuestionTypeEnum {
  FILE = 0,
  TEXT = 1,
  TEXT_AREA = 2,
  DATE = 3,
  NUMBER = 4,
  TRUE_FALSE = 5,
  DROPDOWN = 6,
  CHECKBOX = 7,
  RADIO_BUTTONS = 8,
  WARNINGS = 9,
  LINKS = 10
}

export const QuestionTypeDescriptions: { [key in QuestionTypeEnum]: string } = {
  [QuestionTypeEnum.FILE]: "File",
  [QuestionTypeEnum.TEXT]: "Text",
  [QuestionTypeEnum.TEXT_AREA]: "Text Area",
  [QuestionTypeEnum.DATE]: "Date",
  [QuestionTypeEnum.NUMBER]: "Number",
  [QuestionTypeEnum.TRUE_FALSE]: "True/False",
  [QuestionTypeEnum.DROPDOWN]: "Dropdown",
  [QuestionTypeEnum.CHECKBOX]: "Checkbox",
  [QuestionTypeEnum.RADIO_BUTTONS]: "Radio Buttons",
  [QuestionTypeEnum.WARNINGS]: "Warnings",
  [QuestionTypeEnum.LINKS]: "Links"
};

export enum UseCaseTemplateConditionTypeEnum {
  EQUALTO = 1,
  GREATERTHAN = 2,
  LESSTHAN = 3,
  SELECTED = 4,
  TENANTTYPE = 5,
  USERROLEEQUALTO = 6,
  USERROLENOTEQUALTO = 7
}

export const UseCaseTemplateConditionTypeDescriptions: { [key in UseCaseTemplateConditionTypeEnum]: string } = {
  [UseCaseTemplateConditionTypeEnum.EQUALTO]: "Equal to",
  [UseCaseTemplateConditionTypeEnum.GREATERTHAN]: "Greater than",
  [UseCaseTemplateConditionTypeEnum.LESSTHAN]: "Less than",
  [UseCaseTemplateConditionTypeEnum.SELECTED]: "Item selected",
  [UseCaseTemplateConditionTypeEnum.TENANTTYPE]: "Tenant Type",
  [UseCaseTemplateConditionTypeEnum.USERROLEEQUALTO]: "User Role Equal to",
  [UseCaseTemplateConditionTypeEnum.USERROLENOTEQUALTO]: "User Role Not Equal to"
}

export enum PlanForTrainingTypeEnum {
  FULL = 1,
  PARTIAL = 2,
  NONE = 3
}

export const PlanForTrainingTypeOptions: { [key in PlanForTrainingTypeEnum]: string } = {
  [PlanForTrainingTypeEnum.FULL]: "Full training",
  [PlanForTrainingTypeEnum.PARTIAL]: "Training with modification",
  [PlanForTrainingTypeEnum.NONE]: "No training"
}

export enum ReturnToWorkPlanTypeEnum {
  FULL = 1,
  PARTIAL = 2,
  NONE = 3
}

export const ReturnToWorkPlanTypeOptions: { [key in ReturnToWorkPlanTypeEnum]: string } = {
  [ReturnToWorkPlanTypeEnum.FULL]: "Full work",
  [ReturnToWorkPlanTypeEnum.PARTIAL]: "Work with modification",
  [ReturnToWorkPlanTypeEnum.NONE]: "No work"
}